import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlCargo = '/service/basico/orgaoPublico/informacoesOrgao'
const urlInfoAdm = '/service/basico/administracao/informacoesOrgaoCompleto'

class OrgaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    getInfo() {

        let data = { codigo: this.state.adms.length > 0 ? this.state.adms : ""}

        if(this.state.adms.length == 1){
            //realiza a consulta com Retorno de ADM
            return this.conex.post(urlInfoAdm, JSON.stringify(data))
        }else{
            //realiza a consulta só do Orgao Publico
            return this.conex.get(urlCargo)
        }
    }

}

export default OrgaoService
